import React from 'react'
import { useState } from 'react';
import {Navigate , useLocation} from 'react-router-dom'
const ProtectedRoute = ({children}) => {
    const [user, setuser] = useState(()=>{
          const storedUser =localStorage.getItem('user');
          return storedUser ? JSON.parse(storedUser):null
        })   

    const hasAccess = user;
  return hasAccess ?<Navigate to="/"/>: children 
      
   
  
}

export default ProtectedRoute
